import "core-js/stable";
import "cross-fetch/polyfill";

import React from "react";
import ReactDOM from "react-dom";

import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider } from "@material-ui/core/styles";

import "./firebase";
import { Application } from "./Application";
import { theme } from "./theme";
import { DialogProvider } from "./components/dialog";
import { SnackbarProvider } from "./components/snackbar";
import { BlockingProgressProvider } from "./components/blocking-progress";

ReactDOM.render(
    <React.StrictMode>

        <ThemeProvider theme={theme}>
            <CssBaseline />

            <DialogProvider>
                <SnackbarProvider>
                    <BlockingProgressProvider>

                        <Application />

                    </BlockingProgressProvider>
                </SnackbarProvider>
            </DialogProvider>

        </ThemeProvider>

    </React.StrictMode>,
    document.getElementById("root")
);
